/** View/vwVacancy.cs — the signed-in listing row. `Score` is absent before login. */
export interface VacancyRow {
  trxVacancyID: number
  mstVacancyStepID: number
  VacancyStepName: string | null
  mstCompanyID: number
  CompanyName: string | null
  mstDirectorateID: number
  mstPositionID: number
  PositionName: string | null
  mstCareerID: number
  CareerName: string | null
  mstJobContractsID: number
  JobContractsName: string | null
  ProvinceID: number
  ProvinceName: string | null
  Score?: number | null
  StartVacancy: string | null
  EndVacancy: string | null
  ResponsibilityDescription: string | null
  QualificationDescription: string | null
  isActive: boolean
  TotalCandidate: number
  Email?: string | null
}

/**
 * Company branding on the cards, keyed by the exact `CompanyName` string the
 * upstream returns. Transcribed from `Vacancy.InjectToTemplate`, which
 * hardcoded these three comparisons — including the trailing ", Tbk" on the
 * parent company, which must match character for character.
 */
export const COMPANY_BRANDING: Record<string, { logo: string; website?: string }> = {
  'PT Tower Bersama Infrastructure, Tbk': {
    logo: '/lib/images/logo.png',
    website: 'https://www.tower-bersama.com',
  },
  'PT Permata Karya Perdana': {
    logo: '/lib/images/LOGO-PKP-2023.png',
    // Yes, PKP's card links to ptvti.co.id. That is what the original had.
    website: 'https://www.ptvti.co.id',
  },
  'PT Infrastruktur Digital Indonesia': {
    logo: '/lib/images/ideanet_logo.png',
    website: 'https://www.ideanet.net.id',
  },
}

export const DEFAULT_LOGO = '/lib/images/logo.png'

/** `Vacancy.GetScoreTextClass` */
export function scoreTextClass(score: number | null | undefined): string {
  if (!score || score === 0) return 'text-secondary'
  if (score >= 90) return 'text-success'
  if (score >= 75) return 'text-info'
  if (score >= 60) return 'text-warning'
  return 'text-danger'
}

/** `Vacancy.FormatScoreDisplay` */
export function formatScore(score: number | null | undefined): string {
  if (score === null || score === undefined) return 'N/A'
  return `${Math.round(score)}%`
}

/**
 * `hasStarted` on the card: the Apply button is disabled until StartVacancy.
 * A missing date counts as started, which is how `new Date(undefined) >= x`
 * behaved — NaN comparisons are false, so the original showed "Not Started Yet".
 * That is reproduced rather than inverted.
 */
export function hasVacancyStarted(startVacancy: string | null | undefined): boolean {
  if (!startVacancy) return false
  const start = new Date(startVacancy)
  if (Number.isNaN(start.getTime())) return false
  return new Date() >= start
}
